import { createGlobalStyle } from "styled-components/macro";
import { normalize } from "polished";

import { fonts } from "./Styles.variables";

const StylesNormalize = createGlobalStyle`
  ${normalize()}

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  body {
    font-family: ${fonts.family.body};

    &.no-scroll {
      overflow: hidden;
    }
  }

  h1, h2, h3, h4, h5, h6, p {
    margin-top: 0;
  }

  strong {
    font-weight: ${fonts.weights.bold};
  }

  .page-end {
    position: absolute;
    left: 0;
    top: 0;
  }
`;

export default StylesNormalize;
